export const mangaCategories = [
  { id: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { id: 'korean', name: '韩漫', icon: 'ri-kakao-talk-line' },
  { id: 'japanese', name: '日漫', icon: 'ri-sun-line' },
  { id: 'chinese', name: '国漫', icon: 'ri-flag-2-line' },
  { id: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { id: 'action', name: '热血', icon: 'ri-fire-line' },
  { id: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { id: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { id: 'horror', name: '悬疑', icon: 'ri-ghost-line' },
  { id: 'bl', name: '耽美', icon: 'ri-star-line' },
];

export const mangaList = [
  {
    id: 'manga-1',
    title: '重生之都市修仙',
    author: '十里剑神',
    category: 'chinese',
    tags: ['国漫', '热血', '修仙'],
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20style%20cover%20art%20depicting%20a%20powerful%20male%20cultivator%20in%20flowing%20white%20robes%20standing%20atop%20a%20modern%20skyscraper%20with%20glowing%20spiritual%20energy%20swirling%20around%20him%20dramatic%20lighting%20manga%20style%20illustration%20clean%20composition%20vibrant%20colors&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    rating: 9.6,
    views: '1280万',
    status: '连载中',
    updateChapter: '第387话',
    description: '一代仙尊重生回到高中时代，带着前世记忆，他要在都市中重新踏上修仙之路。前世的遗憾，今世来弥补！',
    chapters: [
      { id: 'ch-1', title: '第1话 重生归来', number: 1 },
      { id: 'ch-2', title: '第2话 校园风云', number: 2 },
      { id: 'ch-3', title: '第3话 初显身手', number: 3 },
      { id: 'ch-4', title: '第4话 暗流涌动', number: 4 },
      { id: 'ch-5', title: '第5话 家族秘辛', number: 5 },
    ],
  },
  {
    id: 'manga-2',
    title: '霸道总裁的契约新娘',
    author: '喵星人工作室',
    category: 'korean',
    tags: ['韩漫', '恋爱', '都市'],
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20romance%20cover%20featuring%20a%20handsome%20CEO%20in%20a%20sharp%20black%20suit%20and%20an%20elegant%20woman%20in%20a%20stunning%20red%20dress%20standing%20close%20together%20in%20a%20luxurious%20penthouse%20with%20city%20night%20view%20soft%20romantic%20lighting%20clean%20composition&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    rating: 9.3,
    views: '960万',
    status: '连载中',
    updateChapter: '第215话',
    description: '为了拯救家族企业，她被迫嫁给冷酷无情的商业帝王。原以为是一场交易，却不知他早已暗许芳心。',
    chapters: [
      { id: 'ch-1', title: '第1话 命运的契约', number: 1 },
      { id: 'ch-2', title: '第2话 新婚之夜', number: 2 },
      { id: 'ch-3', title: '第3话 冰山融化', number: 3 },
    ],
  },
  {
    id: 'manga-3',
    title: '咒术回战',
    author: '芥见下下',
    category: 'japanese',
    tags: ['日漫', '热血', '奇幻'],
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20style%20cover%20featuring%20a%20young%20male%20sorcerer%20with%20spiky%20white%20hair%20and%20a%20black%20blindfold%20surrounded%20by%20dark%20cursed%20energy%20and%20glowing%20blue%20flames%20dramatic%20action%20pose%20intense%20expression%20clean%20manga%20illustration&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    rating: 9.8,
    views: '3560万',
    status: '连载中',
    updateChapter: '第262话',
    description: '高中生虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此踏入了咒术的世界。为了正确面对死亡，他选择成为咒术师。',
    chapters: [
      { id: 'ch-1', title: '第1话 两面宿傩', number: 1 },
      { id: 'ch-2', title: '第2话 秘密处刑', number: 2 },
      { id: 'ch-3', title: '第3话 为了自己', number: 3 },
      { id: 'ch-4', title: '第4话 咒术高专', number: 4 },
    ],
  },
  {
    id: 'manga-4',
    title: '某天成为公主',
    author: 'Spoon',
    category: 'korean',
    tags: ['韩漫', '奇幻', '恋爱'],
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20webtoon%20cover%20featuring%20a%20beautiful%20princess%20with%20long%20golden%20hair%20and%20sparkling%20blue%20eyes%20wearing%20an%20elaborate%20pink%20ball%20gown%20in%20a%20fairytale%20palace%20setting%20with%20soft%20magical%20sparkles%20romantic%20fantasy%20atmosphere%20clean%20illustration&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    rating: 9.5,
    views: '2150万',
    status: '已完结',
    updateChapter: '第152话（完结）',
    description: '穿越到小说中成为注定要死的公主，她决定用尽一切办法活下去。没想到冷酷的父皇竟然开始对她另眼相看。',
    chapters: [
      { id: 'ch-1', title: '第1话 穿越成公主', number: 1 },
      { id: 'ch-2', title: '第2话 冷酷父皇', number: 2 },
      { id: 'ch-3', title: '第3话 改变命运', number: 3 },
    ],
  },
  {
    id: 'manga-5',
    title: '斗破苍穹',
    author: '天蚕土豆',
    category: 'chinese',
    tags: ['国漫', '热血', '奇幻'],
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20manhua%20cover%20featuring%20a%20determined%20young%20male%20warrior%20holding%20a%20massive%20flaming%20sword%20standing%20on%20a%20cliff%20edge%20with%20a%20massive%20dragon%20soaring%20in%20the%20stormy%20sky%20behind%20him%20dramatic%20epic%20composition%20vibrant%20fire%20effects&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    rating: 9.7,
    views: '5280万',
    status: '连载中',
    updateChapter: '第512话',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望的时候，一缕灵魂从他手上的戒指里浮现。',
    chapters: [
      { id: 'ch-1', title: '第1话 陨落的天才', number: 1 },
      { id: 'ch-2', title: '第2话 戒指的秘密', number: 2 },
      { id: 'ch-3', title: '第3话 药老现身', number: 3 },
      { id: 'ch-4', title: '第4话 重新修炼', number: 4 },
      { id: 'ch-5', title: '第5话 纳兰嫣然', number: 5 },
    ],
  },
  {
    id: 'manga-6',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: 'japanese',
    tags: ['日漫', '热血', '奇幻'],
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Japanese%20manga%20cover%20featuring%20a%20young%20demon%20slayer%20with%20dark%20red%20hair%20and%20a%20green%20checkered%20haori%20holding%20a%20nichirin%20katana%20with%20water%20breathing%20effects%20swirling%20around%20him%20dark%20night%20setting%20with%20full%20moon%20intense%20expression&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    rating: 9.9,
    views: '6890万',
    status: '已完结',
    updateChapter: '第205话（完结）',
    description: '大正时期，卖炭少年炭治郎一家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了让妹妹变回人类，炭治郎踏上了成为鬼杀队剑士的道路。',
    chapters: [
      { id: 'ch-1', title: '第1话 残酷', number: 1 },
      { id: 'ch-2', title: '第2话 培育师', number: 2 },
      { id: 'ch-3', title: '第3话 最终选拔', number: 3 },
    ],
  },
  {
    id: 'manga-7',
    title: '天官赐福',
    author: '墨香铜臭',
    category: 'chinese',
    tags: ['国漫', '奇幻', '耽美'],
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20featuring%20two%20elegant%20male%20immortals%20in%20flowing%20traditional%20white%20and%20red%20hanfu%20robes%20surrounded%20by%20cherry%20blossom%20petals%20and%20silver%20butterflies%20in%20a%20heavenly%20palace%20setting%20ethereal%20atmosphere%20soft%20lighting&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    rating: 9.4,
    views: '1820万',
    status: '连载中',
    updateChapter: '第98话',
    description: '八百年前，谢怜飞升成仙，成为万人敬仰的武神。八百年后，他第三次飞升，却成了一个倒霉的破烂神。',
    chapters: [
      { id: 'ch-1', title: '第1话 第三次飞升', number: 1 },
      { id: 'ch-2', title: '第2话 与君山', number: 2 },
      { id: 'ch-3', title: '第3话 花城', number: 3 },
    ],
  },
  {
    id: 'manga-8',
    title: '我独自升级',
    author: 'Chugong',
    category: 'korean',
    tags: ['韩漫', '热血', '奇幻'],
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20intense%20Korean%20webtoon%20cover%20featuring%20a%20powerful%20male%20hunter%20with%20short%20black%20hair%20and%20glowing%20purple%20eyes%20wearing%20a%20black%20combat%20outfit%20surrounded%20by%20shadow%20soldiers%20and%20dark%20energy%20in%20a%20dungeon%20setting%20dramatic%20lighting%20clean%20composition&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    rating: 9.8,
    views: '4560万',
    status: '连载中',
    updateChapter: '第179话',
    description: '十多年前，世界各地突然出现了连接异次元的"门"，而其中觉醒的人类被称为"猎人"。E级猎人成振宇在经历了濒死体验后，获得了神秘的系统。',
    chapters: [
      { id: 'ch-1', title: '第1话 最弱猎人', number: 1 },
      { id: 'ch-2', title: '第2话 双重地下城', number: 2 },
      { id: 'ch-3', title: '第3话 系统的秘密', number: 3 },
      { id: 'ch-4', title: '第4话 开始升级', number: 4 },
    ],
  },
  {
    id: 'manga-9',
    title: '间谍过家家',
    author: '远藤达哉',
    category: 'japanese',
    tags: ['日漫', '搞笑', '日常'],
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Japanese%20manga%20cover%20featuring%20a%20family%20of%20three%20a%20suave%20spy%20father%20in%20a%20suit%20a%20beautiful%20assassin%20mother%20in%20a%20red%20dress%20and%20a%20cute%20little%20girl%20with%20pink%20hair%20and%20a%20telepathic%20dog%20all%20posing%20together%20with%20warm%20smiles%20in%20a%20cozy%20home%20setting&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    rating: 9.6,
    views: '3890万',
    status: '连载中',
    updateChapter: '第98话',
    description: '为了执行任务，最强间谍黄昏需要组建一个临时家庭。他找到了拥有读心能力的女儿阿尼亚和杀手身份的约尔做妻子，三人开始了假面家庭生活。',
    chapters: [
      { id: 'ch-1', title: '第1话 任务开始', number: 1 },
      { id: 'ch-2', title: '第2话 寻找孩子', number: 2 },
      { id: 'ch-3', title: '第3话 入學面試', number: 3 },
    ],
  },
  {
    id: 'manga-10',
    title: '完美世界',
    author: '辰东',
    category: 'chinese',
    tags: ['国漫', '热血', '奇幻'],
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20manhua%20cover%20featuring%20a%20handsome%20young%20male%20cultivator%20with%20long%20flowing%20hair%20riding%20a%20golden%20phoenix%20through%20the%20clouds%20with%20ancient%20floating%20islands%20and%20palaces%20in%20the%20background%20celestial%20atmosphere%20golden%20light%20rays&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    rating: 9.5,
    views: '3120万',
    status: '连载中',
    updateChapter: '第256话',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。',
    chapters: [
      { id: 'ch-1', title: '第1话 大荒少年', number: 1 },
      { id: 'ch-2', title: '第2话 至尊骨', number: 2 },
      { id: 'ch-3', title: '第3话 柳神', number: 3 },
    ],
  },
  {
    id: 'manga-11',
    title: '女神降临',
    author: '猫咪',
    category: 'korean',
    tags: ['韩漫', '恋爱', '校园'],
    cover: 'https://readdy.ai/api/search-image?query=A%20pretty%20Korean%20webtoon%20cover%20featuring%20a%20beautiful%20young%20woman%20with%20long%20brown%20hair%20transforming%20from%20plain%20to%20gorgeous%20with%20makeup%20holding%20cosmetics%20in%20front%20of%20a%20vanity%20mirror%20showing%20two%20different%20reflections%20clean%20bright%20illustration%20modern%20bedroom%20setting&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    rating: 9.2,
    views: '2450万',
    status: '已完结',
    updateChapter: '第230话（完结）',
    description: '因为长相平凡而被欺负的朱静，通过神奇的化妆术华丽变身，成为了校园里的女神。但素颜的秘密是否能一直保守？',
    chapters: [
      { id: 'ch-1', title: '第1话 丑小鸭', number: 1 },
      { id: 'ch-2', title: '第2话 化妆魔法', number: 2 },
      { id: 'ch-3', title: '第3话 校园女神', number: 3 },
    ],
  },
  {
    id: 'manga-12',
    title: '排球少年!!',
    author: '古馆春一',
    category: 'japanese',
    tags: ['日漫', '热血', '体育'],
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20sports%20manga%20cover%20featuring%20a%20short%20energetic%20boy%20with%20orange%20spiky%20hair%20jumping%20high%20to%20spike%20a%20volleyball%20with%20teammates%20in%20the%20background%20gymnasium%20setting%20with%20bright%20lights%20intense%20action%20moment%20clean%20illustration&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    rating: 9.7,
    views: '2780万',
    status: '已完结',
    updateChapter: '第402话（完结）',
    description: '个子矮小的日向翔阳，被乌野高中排球部的"小巨人"所吸引，立志成为排球选手。进入乌野高中后，他与天才二传手影山飞雄成为了搭档。',
    chapters: [
      { id: 'ch-1', title: '第1话 结束与开始', number: 1 },
      { id: 'ch-2', title: '第2话 乌野高中排球部', number: 2 },
      { id: 'ch-3', title: '第3话 搭档', number: 3 },
    ],
  },
];

export const rankings = mangaList
  .sort((a, b) => b.rating - a.rating)
  .slice(0, 10)
  .map((manga, index) => ({
    ...manga,
    rank: index + 1,
  }));

export const latestUpdates = [...mangaList]
  .sort(() => Math.random() - 0.5)
  .slice(0, 8);

export const featuredManga = mangaList.slice(0, 4);

export const heroSlides = [
  {
    id: 'slide-1',
    mangaId: 'manga-5',
    title: '斗破苍穹',
    subtitle: '三十年河东，三十年河西，莫欺少年穷！',
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20epic%20Chinese%20manhua%20banner%20featuring%20a%20determined%20young%20warrior%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20fantasy%20world%20with%20floating%20mountains%20ancient%20temples%20and%20a%20massive%20dragon%20flying%20in%20the%20crimson%20sky%20dramatic%20cinematic%20lighting%20epic%20scale&width=1600&height=700&seq=hero-banner-01&orientation=landscape',
    cta: '立即阅读',
  },
  {
    id: 'slide-2',
    mangaId: 'manga-8',
    title: '我独自升级',
    subtitle: '从E级到最强猎人的逆袭之路！',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20banner%20featuring%20a%20powerful%20male%20hunter%20with%20glowing%20purple%20eyes%20surrounded%20by%20shadow%20warriors%20standing%20in%20a%20ruined%20dungeon%20with%20cracked%20walls%20and%20magical%20portal%20dark%20atmosphere%20intense%20composition%20epic%20scale&width=1600&height=700&seq=hero-banner-02&orientation=landscape',
    cta: '立即阅读',
  },
  {
    id: 'slide-3',
    mangaId: 'manga-6',
    title: '鬼灭之刃',
    subtitle: '用日之呼吸斩断一切鬼之根源！',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20Japanese%20anime%20style%20banner%20featuring%20a%20young%20demon%20slayer%20with%20water%20dragon%20effects%20swirling%20around%20his%20katana%20facing%20a%20fearsome%20demon%20in%20a%20moonlit%20forest%20with%20cherry%20blossom%20petals%20dramatic%20battle%20composition%20cinematic%20scale&width=1600&height=700&seq=hero-banner-03&orientation=landscape',
    cta: '立即阅读',
  },
];